import { IAxiosError } from '@/@types/AxiosError';
import { UserTypeEnum } from '@/@types/User';
import { useQuery } from '@tanstack/react-query';

import { useUserStore } from '@/common/hooks/UserStore';

import { getExportDebitNote } from '../services/getExportDebitNote';

export function useExportDebitNote(
  debitNoteId: string,
  exportOption?: string | null,
) {
  const { userType } = useUserStore();

  const { data, isFetching, error } = useQuery(
    ['getExportDebitNote', debitNoteId, exportOption],
    () => getExportDebitNote(debitNoteId, exportOption),
    {
      enabled:
        !!exportOption &&
        (userType === UserTypeEnum.DEALER || userType === UserTypeEnum.ACCOUNT),
      staleTime: 1000 * 60 * 60, // 1 hour
    },
  );

  return {
    exportDebitNoteData: data?.data,
    isExporting: isFetching,
    isErrorExporting: error as IAxiosError,
  };
}
